import config from "../config";
import request, { requestOptions } from "../utils/request";
const baseUrl = `${config.API_ROOT}/app/chat-quality`;
const ChatQuality = {
  async copyToPlayground({ messageId }) {
    const options = await requestOptions("POST", { messageId }, true);
    const url = `${baseUrl}/copy-to-playground`;
    return request(url, options);
  },
  async debugMessage({
    messageId,
    expectedResponse,
    userMessage,
    assistantResponse,
  }) {
    const options = await requestOptions(
      "POST",
      { messageId, expectedResponse, userMessage, assistantResponse },
      true
    );
    const url = `${baseUrl}/debug-message`;
    return request(url, options);
  },
  async flagMessage({ messageId, expectedResponse, userMessage, assistantResponse }) {
    const options = await requestOptions(
      "POST",
      { messageId, expectedResponse, userMessage, assistantResponse },
      true
    );
    const url = `${baseUrl}/flag-message`;
    return request(url, options);
  },
};

export default ChatQuality;
